export const columns = [
  {
    title: 'ID',
    key: 'detailed_category_id',
    headerClassName: 'category-id'
  },
  {
    title: 'Detailed Category Name',
    key: 'detailed_category_name',
    headerClassName: 'category-name',
  },
  {
    title: 'Updated By',
    key: 'users',
    headerClassName: 'user',
  },
  {
    title: 'Last Updated',
    key: 'created_timestamp',
    headerClassName: 'timestamp',
  }
];